import { HTTP } from '../../http';
import router from '../../router';

const defaultTestResultsErrors = {
    ratedCca: null,
    voltage: null,
    measuredCca: null,
    temperature: null,
    batteryType: null,
    diagnosis: null,
    vehicleId: null
}

const state = {
  currentTestResult: JSON.parse(localStorage.getItem('exideTestResult')) || null,
  testResultSuccess: null,
  currentTestResultErrors: defaultTestResultsErrors
};

const mutations = {
  SET_CURRENT_TEST_RESULT(state, data) {
    state.currentTestResult = data;
    localStorage.setItem('exideTestResult', JSON.stringify(data));
  },
  SET_CURRENT_TEST_ERRORS(state, data) {
    state.currentTestResultErrors = data;
  },
  SET_TEST_RESULT_SUCCESS(state, data) {
    state.testResultSuccess = data;
  }
};

const getters = {
  getCurrentTestResultErrors: state => state.currentTestResultErrors,
  getCurrentTestResult: state => state.currentTestResult,
  getTestResultSuccess: state => state.testResultSuccess
};

const actions = {
  sendBatteryData: ({ commit }, payload) => {
    commit('SET_CURRENT_TEST_ERRORS', defaultTestResultsErrors);

    let batteryData = {
      batteryType: payload.batteryType,
      diagnosis: !payload.diagnosis
        ? null
        : payload.diagnosis.value === 0
        ? 0
        : payload.diagnosis.value === 1
        ? 1
        : 2,
      measuredCca: payload.measuredCca,
      ratedCca: payload.ratedCca,
      temperature: payload.temperature,
      voltage: payload.voltage,
      reserveHealthResult: payload.reserveHealth.value,
      crankingTestResult: payload.crankingHealth.value,
      crankingHealthResult: payload.crankingHealth.value,
      clientId: payload.clientId
    };

    return HTTP.post('/api/send-battery-data', batteryData)
      .then(response => {
        commit('SET_CURRENT_TEST_RESULT', response.data.testResult);
        commit('SET_TEST_RESULT_SUCCESS', true);
        router.push({ name: 'Scan Plates' });
        return response;
      })
      .catch(error => {

        if(error.response.data.hasOwnProperty('errors')) {
          commit('SET_CURRENT_TEST_ERRORS', error.response.data.errors);
        }

        throw error.response;
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
